import moment from 'moment'

export class Ix2044Utils {
    static instance: Ix2044Utils
    utils: any = null

    constructor(utils: any) {
        if (Ix2044Utils.instance) {
            return Ix2044Utils.instance
        }

        this.utils = utils

        Ix2044Utils.instance = this
        return this
    }

    calcGueltigZum(GUELTIGKEIT: number) {
        const dateFilter = {
            0: '',
            1: moment().endOf('month').format('YYYY-MM-DD'),
            2: moment().endOf('month').format('YYYY-MM-DD'),
        } as any

        return dateFilter[GUELTIGKEIT]
    }
}
